module.exports = __webpack_public_path__ + "img/pic03.5724ac4c.jpg";